


export const store = [
  // Rannebennur
  {
    id: 1,
    location: "Rannebennur",
    address: "1,2, CTS No.1855, Railway Station Road, Near Canara Bank, Ranebennur, Haveri, Karnataka, 581115",
    PinCode: "581115",
    map: "",
    category:"Karnataka",
    number1: 9364099708,
    number2: "",
    
  },
  // Honnali
  {
    id: 2,
    location: "Honnali",
    address:
      "NEAR BAMBOO BAZAR MAIN ROAD HONNALI - 577217",
    map: "https://maps.app.goo.gl/Zhnjd88hqRvKyfqn6",
    category:"Karnataka",
    number1: 9364099710,
    number2: "",
   
  },
  // Kustagi
  {
    id: 3,
    location: "Kustagi",
    address: "Buiding no 01 10, Flat no 7688 to 7697, Sri Sai Krishna Residency, Indhira Colony, OPP KSRTC Bus Stop, Kushtagi, Koppal, Karnataka, 583277",
    map: "https://maps.app.goo.gl/mVPja8wK4wFtm8TT6",
    category:"Karnataka",
    number1: 9364099709,
    number2: "",
    
  },
  // Davanagere
  {
    id: 4,
    location: "Davanagere",
    address: "Door No.#294/1 to 5C, Ashoka Road, Below Bheema Lodge, Davanagere, Davanagere, Karnataka, 577002",
    map: "https://maps.app.goo.gl/Bq2Jr7nRXD2E8KwCA",
    category:"Karnataka",
    number1: 9364099711,
    number2: "",
    
  },
  // Gangavati
  {
    id: 5,
    location: "Gangavati",
    address:
      "Near Swastik Hotel, Ganesh Circle, Next to Bank of India, Gangavati-583227 Koppal Dist ",
    map: "https://maps.app.goo.gl/d2Fesvwzvo7f3q3WA",
    category:"Karnataka",
    number1: 9364099662,
    number2: "",
    
  },
   // Periyapatna
   {
    id: 15,
    location: "Periyapatna",
    address: "Ground Floor, No. #1524/1, Yajaman Complex, Santhepete Road, B-M Main Road, Near laxmi clinic, Periyapatna, Mysuru, Karnataka, 571107",
    map: "https://maps.app.goo.gl/e4rH1joVmrFMHS7U9",
    category:"Karnataka",
    number1: 9364099592,
    number2:"",
    
  },
  // HOSPET 
  {
    id: 24,
    location: "Hosapete",
    address:"No.73C, 1st Division, Gandhi Circle, Murane Angandi Circle, Hosapete, Vijayanagara, Karnataka, 583201",
    map: "",
    category:"Karnataka",
    number1: "9364099686",
    number2:"",
    
  },
  // Harihara
  {
    id: 22,
    location: "Harihara",
    address:
      "Ground Floor, Door no 570/A, RCC Building, P B Road , Harihara, Opp Government Bus Stop, Sarathi Industrial Area, Davanagere, Karnataka, 577601",
    map: "https://maps.app.goo.gl/DCCijZbdJveBHetB6",
    category:"Karnataka",
    number1: 9364099684,
    number2:"",
    
  },
   // Chanrayapatna 
   {
    id: 25,
    location: "Chanrayapatna",
    address:"KH no 29, A S no:229, Ward no 3, Near Navodhya Circel, Channarayapatna, Hassan Dist, KA-573116.",
    map: "",
    category:"Karnataka",
    number1: "9364099673",
    number2:"",
    
  },
  // Nuziveedu
  {
    id: 6,
    location: "Nuziveedu",
    address:
      "Ground Floor, Door No.7-1/2, Hanuman Junction Road, Opposite State Bank Of India, Nuzvid, Eluru, Andhra Pradesh, 521201",
    map: "https://maps.app.goo.gl/ji6TKxX3ZVqbp6AS9",
    category: "Andhra" ,
    number1: 9364099679,
    number2:"",
    
  },
  // Repalle
  {
    id: 7,
    location: "Repalle",
    address:
      "Ground Floor, Door No.10-14-123, G K R Complex, Municipal Office Road, Railpet, Opposite Sekhar Book Stall, Repalle, Bapatla, Andhra Pradesh, 522265.",
    map: "https://maps.app.goo.gl/4fCCC6WF85uLJcETA",
    category: "Andhra" ,
    number1: 9364099680,
    number2: "",
   
  },
  // Gorantala
  {
    id: 8,
    location: "Gorantala",
    address: "D No 3/498, Gorantla, Opp Panchaychi Building, Market Street, Gorantla, Sri Sathyasai, Andhra Pradesh, 515231",
    map: "https://maps.app.goo.gl/yRGg8pP3ZnhNThSS7",
    category: "Andhra" ,
    number1: 9364099705,
    number2: "",
    
  },
  // kalyandurgam
  {
    id: 9,
    location: "kalyandurgam",
    address:"No.8-90, VTS Complex, 8th Ward, Hindupur Road, Opposite Reliance Trends, Kalyandurg Rural, Ananthapuramu, Andhra Pradesh, 515761",
    map: "https://maps.app.goo.gl/NEpWBpgMFbWtJEc36",
    category: "Andhra" ,
    number1: 9364099703,
    number2: "",
  },
  // Ananthpur
  {
    id: 10,
    location: "Ananthpur",
    address:
      "D.No. 15-68 Gayathri Complex Opp Vasan Eye Care Raju Road ANANTAPUR-515001",
    map: "https://maps.app.goo.gl/HcUC23Js6Xc8xmLP9",
    category: "Andhra" ,
    number1: 9364099701,
    number2:"",
    
  },
  // Kadiri
  {
    id: 11,
    location: "Kadiri",
    address:
      "Ground Floor, No. 1/332-A, Bypass Road, Opp Radika Theater, Kadiri, Sri Sathyasai, Andhra Pradesh, 515591",
    map: "https://maps.app.goo.gl/nkpGZrHu3tGZA9dE8",
    category: "Andhra" ,
    number1: 9364099707,
    number2: "",
    
  },
  // Palamneru <-> Pattikonda
  {
    id: 12,
    location: "Pattikonda",
    address:
      "#D No:1/1-7-4,Opposite Vegetable Market, Near ambedkar circle Pattikonda 518380",
    map: "https://maps.app.goo.gl/mouMt97WdNGEDB6y9",
    category: "Andhra" ,
    number1: 9364099704,
    number2: "",
    
  },
  // Galiveedu  <> Giddaluru
  {
    id: 13,
    location: "Giddaluru",
    address: "D.NO.8-185-107, Revenue ward 8, Beside Jayaram Lodge, Opp Pamulapalli Railway gate,Nandyal Road, Giddaluru, Pincode : 523357",
    map: "https://maps.app.goo.gl/ur7cVwVe2GNvXbnB7",
    category: "Andhra" ,
    number1: 9364099692,
    number2: "",
   
  },
  // Vijayawada <> tenali
  {
    id: 14,
    location: "Tenali",
    address:
      "D. No. 2-20-4, Nehru Road, Gandhi Chowk, Tenali,Guntur distric, Pincode : 522201",
    map: "https://maps.app.goo.gl/n1KknTAqw9uBQdRc9",
    category: "Andhra" ,
    number1: 9364099690,
    number2:"",
    
  },
 
  // Vempalli
  {
    id: 16,
    location: "Vempalli",
    address: "Ground floor,No 6/185,Patha Peta,Opp BSNL Office,Vempalli-516329",
    map: "https://maps.app.goo.gl/1nhQ131yEdCebjV19",
    category: "Andhra" ,
    number1: 9364099695,
    number2: "",
    
  },
  // Vinjamur
  {
    id: 17,
    location: "Vinjamur",
    address: "#5/78, Beside Sangeetha Mobiles, Vinjamur, Sri Potti Sriramulu Nellore, Andhra Pradesh, 524228",
    map: "https://maps.app.goo.gl/8hGUhj1kb77jj3E99",
    category: "Andhra" ,
    number1: 9364099694,
    number2: "",
    
  },
  // Rayachoti
  {
    id: 18,
    location: "Rayachoti",
    address:
      "Ground Floor, No 61-130, Chittoor Road, Beside Bombay Lodge, Rayachoti, Annamayya, Andhra Pradesh, 516269",
    map: "https://maps.app.goo.gl/tMW9PSut5kBkKVEN6",
    category: "Andhra" ,
    number1: 9364099678,
    number2:"",
    
  },
  // Kalkiri
  {
    id: 19,
    location: "Kalkiri",
    address: "1st Floor, No 6-469, T B Road, Near RTC Busstand, Kalikiri, Annamayya, Andhra Pradesh, 517234",
    map: "https://maps.app.goo.gl/TgXhGZ7eSYcRhujZ7",
    category: "Andhra" ,
    number1: 9364099677,
    number2: "",
    
  },
  // B.Kothakota
  {
    id: 20,
    location: "B.Kothakota",
    address:
      "1st Floor, No 10-169, Banglore Road, Beside Apollo Pharmacy, B Kothakota, Annamayya, Andhra Pradesh, 517370",
    map: "https://maps.app.goo.gl/DCCijZbdJveBHetB6",
    category: "Andhra" ,
    number1: 9364099676,
    number2: "",
   
  },
  // Badvel
  {
    id: 21,
    location: "Badvel",
    address:
      "#8-2-258, Mydukuru  Road, Kadapa Dist,Kadapa, Badvel-516227",
    map: "https://maps.app.goo.gl/DCCijZbdJveBHetB6",
    category: "Andhra" ,
    number1: 9364099681,
    number2: "",
    
  },
  
  // KR Puram, Bangalore
  // {
  //   id: 23,
  //   location: "KR Puram, Bangalore",
  //   address:"Building at no 3, Roj Garden 4th Devasandra main road, KR Puram Bangalore North 560036",
  //   map: "https://maps.app.goo.gl/Aa2tZox7UAkCjZa26",
  //   category:"Bangalore",
  //   number1: 9364099692,
  //   number2:"",
  //   image: [
  //     {
  //       id: 1,
  //       url: KrPuram1,
  //     },
  //     {
  //       id: 2,
  //       url: KrPuram2,
  //     },
  //     {
  //       id: 3,
  //       url: KrPuram3,
  //     },
  //     {
  //       id: 4,
  //       url: KrPuram4,
  //     },
  //     {
  //       id: 5,
  //       url: KrPuram5,
  //     },
  //   ],
  // },
  // Kuppam 
  {
    id: 26,
    location: "Kuppam",
    address:"Plot no6 sri thirupati gangamma complex, palace road, kuppam, chittor, dist-517425",
    map: "",
    category:"Andhra",
    number1: 9364099683,
    number2:"",
    
  },
  // Palamaner 
  {
    id: 27,
    location: "Palamaner",
    address:"Ground Floor, Door No. 12-42/1, Badri Complex, Javali Street, Beside Indian Bank, Palamaner, Chittoor, Andhra Pradesh, 517408",
    map: "",
    category:"Andhra",
    number1: 9364099704,
    number2:"",
    
  },
  // Madanapalli 
  {
    id: 28,
    location: "Madanapalli",
    address:"Do No.14-1-4-4, CTM Road, Near Old Busstand, Madanapalli, Annamayya Dist, AP - 517325",
    map: "",
    category:"Andhra",
    number1: 9364099682,
    number2:"",
    
  },
  // Rayadurgam 
  {
    id: 29,
    location: "Rayadurgam",
    address:"D-No=9-2-230, Laxmi Bazar Anantapur Road, Rayadurgam, Anantapur District, AP -  515865",
    map: "",
    category:"Andhra",
    number1: 9364099691,
    number2:"",
   
  },
  // Vayalpadu 
  {
    id: 30,
    location: "Vayalpadu",
    address:"D No. 1-606, Opp RTC Busstand, Vayalpadu, Annamayya Dist, Andhra Pradesh - 517299",
    map: "",
    category:"Andhra",
    number1: 9364099687,
    number2:"",
    
  },
  // Hunusur 
  {
    id: 32,
    location: "Hunusur",
    address:" Bajar Rashti, Hunusur, Mysuru Dist, KA - 571105.",
    map: "",
    category:"Karnataka",
    number1: 9364099693,
    number2:"",
    
  },
  
];

export default store;
